'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

type IHeaderLinkProps = {
  label: string | null;
  link: string;
};

export const HeaderLink = ({ label, link }: IHeaderLinkProps) => {
  const pathname = usePathname();

  const isActive = pathname === link || pathname.startsWith(`${link}/`);

  return (
    <li>
      <Link
        href={link}
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_button',
            click_id: link,
            click_label: label,
          });
        }}
        className={`relative block cursor-pointer pb-1 text-xs font-semibold no-underline transition-all after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full after:origin-center after:scale-x-0 after:transition-transform after:duration-300 after:content-[''] md:text-sm ${isActive ? 'text-white after:scale-x-100 after:bg-white' : 'text-white after:bg-white/70 hover:after:scale-x-100'}`}
      >
        {label}
      </Link>
    </li>
  );
};
